var RE = /\s/g

module.exports = function(str){
    if (!str){
        return ''
    }

    return str.replace(RE, '')
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/stripWhitespace.js
 ** module id = 825
 ** module chunks = 0
 **/